<script>
  import {M} from "../../external";

  export let data, next;

  $: {
    if (!data.name) {
      data.name = "";
    }
    if (!data.id) {
      data.id = -1;
    }
  }

  let onNext = () => {
    next();
  };
</script>

<div class="flex-1 overflow account-settings store-products">
  <div class="col20 f-left">
    <div class="top-background-wrapper wide-top-background">
      <div class="top-background" style="max-width: 850px;">
        <div class="text-wrapper"></div>
      </div>
    </div>
    <div class="content-wrapper horizontal-flex-table" style="max-width: 850px; margin-top: 100px;" data-role="table-content">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer" style="box-shadow: none; padding: 0;">
          <div class="system-emails-wrapper">
            <div class="col20 f-left t-center mb-15"><span class="material-icons-outlined fingerprint-icon" style="font-size: 26px;"> sms </span></div>
            <h2 class="col20 f-left t-center" style="font-size: 26px;">{M.CAMPAIGN_NAME}</h2>
            <div class="col20 f-left email-section-description t-center mt-10 mb-25">{M.MESSAGE_NAME_DESC}</div>
            <div class="col20 f-left t-center mb-45">
              <input
                type="text"
                bind:value={data.name}
                name="name"
                class="transition-all big-input-settings f-none inline-block t-center"
                style="max-width: 400px;font-size: 18px;"
                placeholder={M.ENTER_CAMPAIGN_NAME} />
            </div>
            <div class="col20 f-left flex justify-center mt-25 mb-35">
              <a data-action="nextPage" on:click={onNext} class="big-button blue circle-effect transition-bg f-left" style="margin-left:5px;">{M.NEXT} →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
